import { uploadFile } from '../../services/media';
import type { Editor, FileLoader } from 'ckeditor5';
import type { MediaFile, MediaImage } from '../../models/media';

class MediaUploadAdapter {
  private loader: FileLoader;
  private xhr: XMLHttpRequest | null = null;

  constructor(loader: FileLoader) {
    this.loader = loader;
  }

  async upload(): Promise<{ default: string }> {
    try {
      const file = await this.loader.file;
      if (!file) {
        throw new Error('No file selected');
      }
      
      // Create form data
      const formData = new FormData();
      formData.append('file', file);
      formData.append('folder_id', '2'); // CMS folder ID
      
      // Upload the file
      const response = await uploadFile(file);
      
      if (!response.success || !response.file) {
        throw new Error(response.message || 'Upload failed');
      }

      // Get the file URL based on the file type
      const uploadedFile = response.file;
      const fileUrl = this.getFileUrl(uploadedFile);
      
      // Return the URL of the uploaded file
      return {
        default: fileUrl
      };
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }

  private getFileUrl(file: MediaFile | MediaImage): string {
    if ('thumbnail_url' in file) {
      // It's an image, use the original thumbnail URL
      return file.thumbnail_url.small || file.file;
    }
    // It's a regular file, use the file URL
    return file.file;
  }

  abort(): void {
    if (this.xhr) {
      this.xhr.abort();
    }
  }
}

export function MediaUploadAdapterPlugin(editor: Editor): void {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader: FileLoader) => {
    return new MediaUploadAdapter(loader);
  };
} 